import useTranslation from "hooks/useTranslation"
import { POST } from "api/request"
import { useState } from "react"
import * as url from 'api/urls'
import Modal from "./Modal"

interface AddPhotosModalProps {
  onClose: () => void
  onReload?: () => void
  fromPublic?: boolean
  id: string | undefined
}

interface Response {
  result: boolean
  quota_exceeded?: boolean
}

const AddPhotosModal: React.FC<AddPhotosModalProps> = ({ id, fromPublic, onClose, onReload }) => {
  const [isSending, setSending] = useState<boolean>(false)
  const [response, setResponse] = useState<Response[] | null>(null)
  const [media, setMedia] = useState<File[]>([])

  const { t } = useTranslation('addphotosmodal')
  const handleMediaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setMedia([...media, ...Array.from(event.target.files)])
    }
  }

  const handleRemoveMedia = (index: number) => {
    setMedia(media.filter((_, i) => i !== index))
  }


  const handleSubmit = async () => {
    if (media.length === 0) return
    setSending(true)
    const formData = new FormData()

    media.forEach((photo, index) => {
      formData.append(`media[${index}]`, photo)
    })

    try {
      const response = await POST(url.uploadBoard(id), {
        form: formData,
      })
      if (response.ok) {
        setResponse(response.data)
        if (onReload) onReload()
      } else {
        alert('W trakcie wysyłania wystąpił błąd')
      }
    } catch (err) {
      console.error(err)
    } finally {
      setSending(false)
    }
  }

  return (
    <Modal
      icon='add-photo'
      onClose={onClose}
      title={response ? t('sent') : t('add_photos')}
      primaryButton={response ? '' : isSending ? t('sending') : t('send')} primaryButtonAction={handleSubmit}
      secondaryButton={response ? t('close') : t('cancel')} secondaryButtonAction={'close'}>

      <div className="modal__addPost">
        {response
          ? <div className="info">
            {response.some((r) => !r.result)
              ? <ul>
                {response.map(({ result, quota_exceeded }, idx) => <li key={idx}>
                  {media[idx].name} - {t(quota_exceeded ? 'possible_limit_exceeded' : result ? 'sent' : 'an_error_occurred')}
                </li>)}
              </ul>
              : fromPublic
                ? <div className="center">{t('photos_will_be_sent')}</div>
                : <div className="center">{t('sent_photos')}</div>}
          </div>
          : <>
            <div className="myInput">
              <label>{t('add_more')}</label>
              <div className='drop small' onClick={() => document.getElementById('mediaInput')?.click()}>
                <i className='icon icon--add-photo s32'></i>
                <span>{t('click_to_add')}</span>
              </div>
              <input
                type="file"
                id="mediaInput"
                style={{ display: 'none' }}
                onChange={handleMediaChange}
                accept="image/*,video/*"
                multiple
              />
            </div>
            {media.length > 0 && (<>
              <div className='preview'>
                {media.map((file, index) => {
                  const fileURL = URL.createObjectURL(file)
                  return file.type.startsWith('image/') ? (<div>
                    <div className="iconWrap" onClick={() => handleRemoveMedia(index)}><i className="icon icon--close"></i></div>
                    <img
                      key={index}
                      src={fileURL}
                      alt={`Preview ${index}`}
                      style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '5px' }}
                    />
                  </div>
                  ) : (
                    <div>
                      <div className="iconWrap" onClick={() => handleRemoveMedia(index)}><i className="icon icon--close"></i></div>
                      <video
                        key={index}
                        src={fileURL}
                        autoPlay
                        muted
                        style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '5px' }}
                      />
                    </div>
                  )
                })}
              </div>
            </>
            )}
          </>}
      </div>
    </Modal >
  )
}

export default AddPhotosModal
